export const EXTRA_DETAILS_QUESTIONS = [
  {
    id: 1,
    section: 'Psychology',
    sectionKey: 'psych' as const,
    q: 'How long have you been single (or not in an official relationship) up to now?',
    type: 'radio',
    options: [
      'Less than 6 months',
      '6 months to 2 years',
      'More than 2 years',
      'Never had an official relationship',
    ],
  },
  {
    id: 2,
    section: 'Psychology',
    sectionKey: 'psych' as const,
    q: 'What is the current status of your relationship with your ex (if any)?',
    type: 'radio',
    options: [
      'Completely cut off — treat them like a stranger',
      'Still keep casual contact due to work or mutual friends',
      'Still close friends — we talk often and meet up regularly',
      'I have never had an ex',
    ],
  },
  {
    id: 3,
    section: 'Psychology',
    sectionKey: 'psych' as const,
    q: 'When conflict or arguments arise in a relationship, what is your natural reaction?',
    type: 'radio',
    options: [
      'Speak up directly — want to talk things through and resolve it right away',
      'Stay quiet for a few hours or a day to cool off, then talk later',
      'Avoid and go silent for a long time (cold war) or disappear to soothe myself',
      'Easily emotional outbursts (crying, harsh words) but anger fades quickly afterward',
    ],
  },
  {
    id: 4,
    section: 'Psychology',
    sectionKey: 'psych' as const,
    q: 'When moving in together, what role do you want to take in managing the household?',
    type: 'radio',
    options: [
      'I want to take the lead on big decisions (direction, major finances, external affairs)',
      'I prefer stepping back — caring for the home, cooking, and nurturing our nest',
      'Fully equal — each person handles their own tasks; big decisions are discussed 50/50',
      'Depends on my partner',
    ],
  },
  {
    id: 5,
    section: 'Practical',
    sectionKey: 'practical' as const,
    q: 'What is your view on pets in a shared living space?',
    type: 'radio',
    options: [
      'I have pets (dog/cat) and treat them like family',
      'I do not have pets but love animals and am open to raising them with my partner',
      'I do not dislike them but do not want pets indoors — worried about mess or shedding',
      'I am allergic to animal fur / absolutely cannot live with pets',
    ],
  },
  {
    id: 6,
    section: 'Practical',
    sectionKey: 'practical' as const,
    q: 'How much do religion / spirituality influence your life?',
    type: 'radio',
    options: [
      'Very important. I am religious or strongly believe in feng shui, numerology, astrology (I hope my partner respects this or shares the same beliefs)',
      'Moderate. I observe traditions but do not let them affect romance',
      'Not important at all. I am practical / non-religious',
      'I prefer not to connect with people who are overly focused on religion / spirituality',
    ],
  },
  {
    id: 7,
    section: 'Practical',
    sectionKey: 'practical' as const,
    q: 'How would you rate your overall health (physical & mental) right now?',
    type: 'radio',
    options: [
      'Excellent: I live healthily, have plenty of energy, and stable mental well-being.',
      'Good: Health is stable; occasional stress or minor illness but I can balance myself.',
      'Average: Generally fine; a few chronic conditions but they do not majorly affect daily life',
      'Health or mental concerns: I have underlying conditions or am in treatment — I hope to find someone understanding and accepting.',
    ],
  },
  {
    id: 8,
    section: 'Practical',
    sectionKey: 'practical' as const,
    q: 'How often do you get routine sexual health checkups (STDs/HIV)?',
    type: 'radio',
    options: [
      'Every 3–6 months (very thorough and responsible)',
      'Once a year / or before entering a new relationship',
      'Only when my body shows unusual symptoms',
      'I have never been tested',
    ],
  },
  {
    id: 9,
    section: 'Sex',
    sectionKey: 'sex' as const,
    q: 'What are your views and habits around sexual health protection?',
    type: 'radio',
    options: [
      'Regularly use PrEP — pre-exposure prophylaxis, so condoms are not necessary.',
      'Always use condoms even when on PrEP — pre-exposure prophylaxis',
      'Only have unprotected sex when both partners are confirmed safe',
      'Fairly open and flexible depending on how I feel in the moment',
    ],
  },
  {
    id: 10,
    section: 'Sex',
    sectionKey: 'sex' as const,
    q: 'What is your ideal level of need and frequency of intimacy in a romantic relationship?',
    type: 'radio',
    options: [
      'High need (Frequent: about 3–5 times/week. Sex is a core catalyst for keeping the spark alive.)',
      'Moderate need (Balanced: about 1–2 times/week or on weekends. Quality over quantity.)',
      'Low need (Gentle: every few weeks or only when both are truly comfortable.)',
      'Emotion-focused (Limited/low need: I prefer hugs, kisses, and emotional connection over physical intimacy.)',
    ],
  },
  {
    id: 11,
    section: 'Sex',
    sectionKey: 'sex' as const,
    q: 'Which bedroom style or preference best describes you?',
    type: 'checkbox',
    options: [
      'Romantic / Traditional (Prefer gentle, sweet intimacy — candles, music, and emotional focus (vanilla).)',
      'Intense / Dominant (Prefer wild passion, heat, with a strong take-charge energy)',
      'Open to new experiences (Willing to try new settings, toys (sex toys), or roleplay)',
      'Specific tastes (BDSM, or light consensual spice like blindfolds, restraints, spanking)',
      'Just warmth (Method does not matter — as long as our bodies connect and feel safe)',
    ],
  },
  {
    id: 12,
    section: 'Pressure',
    sectionKey: 'pressure' as const,
    q: 'How independent or dependent are you on your parents/family when choosing a partner?',
    type: 'radio',
    options: [
      '100% my decision (family cannot interfere with my personal happiness)',
      '70% my decision (I hope to find someone tactful enough to win my parents over later)',
      '30% my decision (still working on independence — I want a strong partner by my side)',
      '0% (My family is very strict — my partner must pass my parents\' screening)',
    ],
  },
  {
    id: 13,
    section: 'Pressure',
    sectionKey: 'pressure' as const,
    q: 'How comfortable are you showing affection (holding hands, light hugs, PDA) in public?',
    type: 'radio',
    options: [
      'All in (Happy to show affection anywhere)',
      'Comfortable (Confident with moderate PDA in public — I do not mind strangers looking)',
      'Limited (Only in safe spaces like familiar cafés, cinemas, or trips abroad; keep distance on busy streets)',
      'Absolutely not (I want to stay completely private in public to protect my personal life)',
    ],
  },
];

export const NARRATIVE_QUESTIONS = [
  'When work is set aside, what activities usually fill a full day off for you?',
  'If you could praise yourself for one thing, which quality or good habit are you most proud of?',
  'Paint a picture of an ideal date that would make you feel most comfortable and genuinely moved?',
  'In love, how do you want your partner to communicate and share with you?',
];

export const PERSONALITY_QUIZ = [
  {
    q: 'What is your energy like when you show up at a crowded lounge or event?',
    options: [
      { text: 'Sit at the bar, order a cocktail, quietly observe, and only have deep conversations with people who match my vibe.', type: 'A' },
      { text: 'Wear a stunning outfit, socialize confidently, connect with people, and become the center of attention.', type: 'B' },
      { text: 'Go with close friends, take photos for them, and make sure everyone is fed and no one feels left out.', type: 'C' },
      { text: 'Hang out in a cozy sofa corner, be the hype person telling funny stories or catching drama with the crew.', type: 'D' },
    ],
  },
  {
    q: 'When moving in with your partner, which responsibility are you most confident handling?',
    options: [
      { text: 'Planning finances, managing bills, and designing travel itineraries for both of us.', type: 'A' },
      { text: 'Styling the home, playing lo-fi music, diffusing essential oils — keeping the space romantic like a 5-star hotel.', type: 'B' },
      { text: 'Cooking everyday comfort food, keeping the home tidy, and giving massages after a long workday.', type: 'C' },
      { text: 'Being the one who keeps laughter alive, breaks boredom, and occasionally whisking my partner away to a distant homestay.', type: 'D' },
    ],
  },
  {
    q: 'What is your clearest way of giving a green light to someone you have a crush on?',
    options: [
      { text: 'Probe their interests and work, then open with a thoughtful, knowledge-rich topic they care about.', type: 'A' },
      { text: 'Engage heavily on social media, like their stories daily, and invite them to movies or dates — direct, no games.', type: 'B' },
      { text: 'Prepare a small gift tailored to their taste, or quietly pick them up and look after the little details.', type: 'C' },
      { text: 'Reply instantly with witty memes, teasing charmingly enough to make them laugh all day.', type: 'D' },
    ],
  },
  {
    q: 'When your partner suddenly goes quiet or is under heavy work pressure, how do you handle it?',
    options: [
      { text: 'Respect their space, keep a comfortable distance, and message: "Whenever you need solutions, I am here."', type: 'A' },
      { text: 'Buy flowers or a surprise gift, rush over for a tight hug and reassurance so they do not feel alone.', type: 'B' },
      { text: 'Cook a bowl of hot soup (or order their favorite food), remind them to hydrate, and handle everything around them so they can rest.', type: 'C' },
      { text: 'Take them out for drinks to change the mood, tell funny stories, or pull them out of a suffocating space to decompress.', type: 'D' },
    ],
  },
  {
    q: 'Which communication red flag makes you immediately cut contact?',
    options: [
      { text: 'Shallow talk, superficial thinking, or lacking basic foundational knowledge.', type: 'A' },
      { text: 'Bland texting, painfully slow replies, and zero initiative in the relationship.', type: 'B' },
      { text: 'Rude behavior toward people around them (servers, drivers) or an overly selfish, careless lifestyle.', type: 'C' },
      { text: 'Too serious and rigid — cannot take a joke, easily offended, and does not know how to enjoy life.', type: 'D' },
    ],
  },
];

export type PersonalityVariantKey =
  | 'A1' | 'A2' | 'A3'
  | 'B1' | 'B2' | 'B3'
  | 'C1' | 'C2' | 'C3'
  | 'D1' | 'D2' | 'D3';

export const PERSONALITY_VARIANTS: Record<
  PersonalityVariantKey,
  { shareTitle: string; shareHook: string }
> = {
  A1: {
    shareTitle: '#Addictive_Mystery_Vibe | #Master_of_Silence',
    shareHook:
      'The world outside is already too loud. If you are tired of flashy, shallow things too, stop here — let us create a peaceful pocket of quiet together.',
  },
  A2: {
    shareTitle: '#Oasis_of_Thought | #Master_Observer',
    shareHook:
      'Calm presence and intellectual depth are magnetic on their own. No need to speak loudly — people on the same wavelength find each other. 🧠',
  },
  A3: {
    shareTitle: '#Emotional_Cipher | #Rational_Operating_System',
    shareHook:
      'Love me and skip the drama — just steady peace and a clear future roadmap. If you think you can crack this code, jump in! 🔐',
  },
  B1: {
    shareTitle: '#Heartthrob_Everywhere | #VIP_Date_Magnet',
    shareHook:
      'Love should burn — I do not do ambiguity. If you want a romance full of surprises and 5-star romance, line up now!',
  },
  B2: {
    shareTitle: '#Sun_of_the_Night_Lounge | #Proactive_Champion',
    shareHook:
      'Once I set my sights on someone, the green light is unmistakable. Life is too short for hide-and-seek — if you like someone, make a move! ⚡',
  },
  B3: {
    shareTitle: '#Ignite_the_Feeling | #VIP_Dater_Alert',
    shareHook:
      'Deadlines may get boring beside me, but love never goes flat. Ready to take your hand and escape the world for a change of scenery! 🥂',
  },
  C1: {
    shareTitle: '#National_Homebody_Bear | #Peaceful_Rooftop',
    shareHook:
      'Shark out in the world, warm meal and sweet soup waiting at home. Looking for someone willing to move in so I can spoil them.',
  },
  C2: {
    shareTitle: '#Peace_Charging_Station | #Spoil_Ambassador',
    shareHook:
      'The world outside wore you out, right? Come here — I will hug you, and meals, water, and warmth every night are on me! 🍳',
  },
  C3: {
    shareTitle: '#Safe_Harbor | #Quiet_Healer',
    shareHook:
      'I show love through real actions, not sweet talk. Worth being the final stop of a lifetime. 🧸',
  },
  D1: {
    shareTitle: '#Salty_Vitamin | #Healing_Comedy_Champion',
    shareHook:
      'Life already has enough exhausting deadlines — love me and laugh until your sides hurt every day. Hit apply to be my partner for instant perks!',
  },
  D2: {
    shareTitle: '#Lord_of_Hangouts | #Drama_Broadcaster',
    shareHook:
      'Single life is freedom, but one witty teammate to party and catch gossip with every night is twice the fun! 🍻',
  },
  D3: {
    shareTitle: '#Modesty_Gone_Flying | #God_of_Laughter',
    shareHook:
      'Been good long enough — who can handle this level of spice from me? Apply to be my partner now and get a daily basket of laughs! 🎢',
  },
};

export const PERSONALITY_RESULTS = {
  A: {
    title: 'Introverted / Low-key / Deep',
    shareTitle: '#Addictive_Mystery_Vibe | #Master_of_Silence',
    shareHook:
      'The world outside is already too loud. If you are tired of flashy, shallow things too, stop here — let us create a peaceful pocket of quiet together.',
    desc: 'You carry the energy of a peaceful oasis. You do not need to be the loudest person in the room to attract attention — your calm, low-key presence and intellectual depth are magnetic on their own. In love, you are deeply loyal, thoughtful, and value what is genuine. Whoever wins your heart holds a rare treasure.',
  },
  B: {
    title: 'Radiant Energy & Crowd Magnetism',
    shareTitle: '#Heartthrob_Everywhere | #VIP_Date_Magnet',
    shareHook:
      'Love should burn — I do not do ambiguity. If you want a romance full of surprises and 5-star romance, line up now!',
    desc: 'Your heart burns bright and you are boldly romantic. You redefine what romance means. Once you set your sights on someone, you give a clear green light with overflowing proactive energy. Beside you, your partner will never feel neglected or bored — life together becomes a string of sweet trips and experiences.',
  },
  C: {
    title: 'Protective Instinct & Solid Home Base',
    shareTitle: '#National_Homebody_Bear | #Peaceful_Rooftop',
    shareHook:
      'Shark out in the world, warm meal and sweet soup waiting at home. Looking for someone willing to move in so I can spoil them.',
    desc: 'You are a rare gem in the digital age — someone who shows love through action, not lip service. Cooking well, listening deeply, and worrying over everything from a warm shirt to a cup of hot water every night is the privilege of whoever has you. You bring absolute safety and are worth being the final harbor of true love.',
  },
  D: {
    title: 'Wit & Boundless Freedom',
    shareTitle: '#Salty_Vitamin | #Healing_Comedy_Champion',
    shareHook:
      'Life already has enough exhausting deadlines — love me and laugh until your sides hurt every day. Hit apply to be my partner for instant perks!',
    desc: 'You possess "wit" — one of the most charming assets there is. You can turn suffocating moments light with one clever joke. Independent, freedom-loving, and always knowing how to enjoy life at its best. Loving you is like owning an endless source of healing energy for the soul.',
  },
};

export const FROZEN_HEART_META = {
  title: 'FROZEN HEART: DECODING THE SINGLEHOOD CURSE',
  subtitle: 'The Frozen Heart',
  intro:
    'Are you single because your standards are sky-high, because past wounds have not healed, or simply because... you are too lazy to leave your cozy bed? What "temperature" is your heart at in the world of singlehood? Take 2 minutes to decode your frozen frequency and get a one-of-a-kind profile card perfect for posting on social media!',
  notices: [
    'This test has 10 hidden psychological multiple-choice questions designed specifically for the community.',
    'Answer with your most natural reflex and be honest with yourself (no one sees your answers except the secure system).',
    'Estimated time: 90 seconds.',
  ],
};

export const FROZEN_HEART_TAG_D = {
  badge: '⚠️ WARNING: LOWKEY LOVER — HIGH PRIVACY BARRIERS',
  cardBadge: '⚠️ WARNING: LOWKEY LOVER',
  supplement:
    'Our scan shows you are under heavy pressure from family/social barriers or a job position that requires a discreet lifestyle (staying under the radar). You hesitate to move forward because you fear hurting your partner or exposing your private identity. You need a similarly low-key/discreet partner who understands and accepts a quiet, non-showy but enduring love. We have a pool of intellectual, discreet clients like you for fully secure 100% confidential matching.',
};

export const SINGLE_QUIZ = [
  {
    q: 'When scrolling and you see a profile of someone extremely your type — great looks, impressive job — what is your first reaction?',
    options: [
      { text: 'Tap in and scrutinize carefully, checking for anything that does not match my standards.', type: 'A' },
      { text: 'Think they are probably shallow or a trap-boy — someone this perfect is not for me → swipe away.', type: 'B' },
      { text: 'Drop a like and keep scrolling — too lazy to message, start a conversation, or get to know someone from scratch.', type: 'C' },
    ],
  },
  {
    q: 'How have your ideal weekends usually looked over the past 6 months?',
    options: [
      { text: 'Hunting new upscale cafés, visiting exhibitions, or going on dates if I find someone worthy.', type: 'A' },
      { text: 'Only café with 1–2 ride-or-die friends, telling old stories to feel safe.', type: 'B' },
      { text: 'Sleep in, order delivery, watch shows, scroll online all day. Only leave home when absolutely necessary.', type: 'C' },
    ],
  },
  {
    q: 'Think about your most recent romance (or someone you were ambiguous with) — why did it stop?',
    options: [
      { text: 'It faded, or I noticed things that did not meet my standards and pulled back on my own.', type: 'A' },
      { text: 'I was cheated on, deeply hurt, or they suddenly ghosted me and it still haunts me.', type: 'B' },
      { text: 'I have never had a real relationship — mostly crushes or ambiguous situations lasting a few weeks.', type: 'C' },
    ],
  },
  {
    q: 'You have a list of standards for a future partner (age, income, looks, role...). How flexible are you?',
    options: [
      { text: '100% rigid. Missing one standard means no commitment — I would rather stay single than lower my value.', type: 'A' },
      { text: 'I can soften some flexible standards, but they must make me feel safe and not be unfaithful.', type: 'B' },
      { text: 'Anything goes — just need chemistry and someone who can handle my lazy going-out habits.', type: 'C' },
    ],
  },
  {
    q: 'If you had to pick one line to describe your current single status, which would it be?',
    options: [
      { text: '"I would rather be alone in splendor than endure a relationship beneath my level."', type: 'A' },
      { text: '"I crave being loved but fear giving my heart to the wrong person and being abandoned again."', type: 'B' },
      { text: '"I really want a partner, but the thought of meeting people and replying to messages from scratch is exhausting."', type: 'C' },
    ],
  },
  {
    q: 'How do you currently handle family pressure to settle down?',
    options: [
      { text: 'Talk straight or have come out to claim autonomy — I do not care what others say.', type: 'A' },
      { text: 'Feel exhausted and overwhelmed, choosing silence or avoidance — I do not want to go home.', type: 'B' },
      { text: 'Quietly exploring sham marriage or contract marriage options to manage private life.', type: 'C', triggerTagD: true },
    ],
  },
  {
    q: 'When someone messages you online to get acquainted, what makes you most likely to ghost/block/unmatch?',
    options: [
      { text: 'Bland texting, lack of cultural depth, or constantly asking "Have you eaten yet".', type: 'A' },
      { text: 'After a few messages they push for explicit photos, hotel invites, or aggressively probe my privacy.', type: 'B' },
      { text: 'Slow replies (hours between messages) — kills my motivation to keep the conversation going.', type: 'C' },
    ],
  },
  {
    q: 'Imagine moving in with your partner — what scares you most?',
    options: [
      { text: 'Money conflicts, shared finances, and mismatched spending habits.', type: 'A' },
      { text: 'Fear that love fades, they seek a third party, or push for an open relationship.', type: 'B' },
      { text: 'Losing freedom and daily personal space (going out, doing things, gaming — always having to report).', type: 'C' },
    ],
  },
  {
    q: 'How confident are you in your current appearance and financial ability?',
    options: [
      { text: 'Fairly confident — financially independent, I take care of my looks, and deserve an equally capable partner.', type: 'A' },
      { text: 'I feel I need to lose weight, earn more, or improve myself before I dare to love.', type: 'B' },
      { text: 'Average — enough to get by, nothing standout but comfortable living.', type: 'C' },
    ],
  },
  {
    q: 'How often do you meet and get to know completely new people in the community (outside work)?',
    options: [
      { text: 'Every few months, mainly through quality connections or VIP friend introductions.', type: 'A' },
      { text: 'Occasionally swipe dating apps when lonely, but almost never meet in real life.', type: 'B' },
      { text: 'Nearly zero. Year-round cycle of work and home — social circle frozen solid.', type: 'C' },
    ],
  },
];

export type FrozenHeartVariantKey =
  | 'A1' | 'A2' | 'A3'
  | 'B1' | 'B2' | 'B3'
  | 'C1' | 'C2' | 'C3';

export const FROZEN_HEART_VARIANTS: Record<
  FrozenHeartVariantKey,
  { shareTitle: string; shareHook: string }
> = {
  A1: {
    shareTitle: '#Aristocratic_Single',
    shareHook:
      'It is not that I am unwanted — the market has not produced anyone worthy of this configuration yet. High standards — what is wrong with that? 😎',
  },
  A2: {
    shareTitle: '#Lord_of_Standards',
    shareHook:
      'I would rather be alone in glory than endure a mismatched relationship. My backbone is saying "No" to half-hearted love! 🥂',
  },
  A3: {
    shareTitle: '#Clear_Radar',
    shareHook:
      'Love me and skip the drama — just peace and clear plans. If you are confident you are on the right frequency, jump in and prove it! 📐',
  },
  B1: {
    shareTitle: '#Branch_Bends_Fear_Bird',
    shareHook:
      'This heart is temporarily closed for maintenance after a few emotional storms. Looking for someone patient enough to thaw it... 🩹',
  },
  B2: {
    shareTitle: '#Cautious_Ambassador',
    shareHook:
      'Thick ice is self-defense, not heartlessness. I am not rushing — slow and steady love is worth the wait. 🛡️',
  },
  B3: {
    shareTitle: '#Warm_Soul_Underneath',
    shareHook:
      'Shy and cold on the outside, but a storm underneath. Need a safe hug more than a thousand sweet nothings. 🕯️',
  },
  C1: {
    shareTitle: '#Hermit_Champion',
    shareHook:
      'Cupid knocked right while I was sleeping in. If you are serious, drag me out of the house — I am too lazy to make new friends! 🛌',
  },
  C2: {
    shareTitle: '#Homebody_Addict',
    shareHook:
      'Weekend radius: from bed to fridge. I want love but hate going out to meet people — someone deliver a partner to my door! 🍕',
  },
  C3: {
    shareTitle: '#Peaceful_Oasis',
    shareHook:
      'The world outside is grinding deadlines — come home and I will cook you a warm meal. Lazy to go out, but number one at caring for a partner! 🍳',
  },
};

export const SINGLE_RESULTS = {
  A: {
    title: 'President of the Picky Club',
    shareTitle: '#Aristocratic_Single',
    temperature: '-5°C',
    temperatureLabel: 'Slightly cold',
    shareHook:
      'It is not that I am unwanted — the market has not produced anyone worthy of this configuration yet. High standards — what is wrong with that? 😎',
    analysis:
      'You are not lacking attraction or opportunity — you have an extremely strict standards filter. You are self-directed, financially independent, and have high aesthetic taste. You would rather endure elegant solitude than "lower your price" for an ambiguous, unclear, or mismatched relationship. You tend to scan and find flaws in others quickly so you can pull back first and protect your time.',
    matchmakerAdvice:
      'High standards are good for filtering out emotional "trash," but sometimes your filter is so sensitive you miss rough gems that need time to shine. Try keeping one core standard (e.g., sincerity/intelligence) and relaxing two soft ones (e.g., gym-perfect looks or opening-message style). Give them a second date before hitting "reject."',
  },
  B: {
    title: 'Cautious Ambassador',
    shareTitle: '#Branch_Bends_Fear_Bird',
    temperature: '-35°C',
    temperatureLabel: 'Frozen in self-defense',
    shareHook:
      'This heart is temporarily closed for maintenance after emotional storms. Looking for someone patient and warm enough to melt this ice together... 🩹',
    analysis:
      'You are deeply emotional by nature, but scars from the past (betrayal, cheating, or sudden ghosting) turned you into a bird afraid of bent branches. You built walls too thick and view new people with suspicion: "Are they sincere or another trap-boy?" You would rather choose safe solitude than risk being hurt again.',
    matchmakerAdvice:
      'The walls keep you safe but also block good people trying to reach you. You do not need to throw away your defenses overnight — you need a "slow and steady" relationship path. Let our exclusive matchmaking service vet candidates and ensure they are 100% serious before introduction, so you can open up at your own pace.',
  },
  C: {
    title: 'Chronic Homebody',
    shareTitle: '#Hermit_Champion',
    temperature: '-70°C',
    temperatureLabel: 'Permanently frozen',
    shareHook:
      'Cupid knocked right while I was sleeping in and binge-watching. If you are serious, drag me out of the house — I am too lazy to make new friends! 🛌',
    analysis:
      'Your singlehood curse is not about looks or money — it is the word "LAZY." You are addicted to the safe space of your bed, weekend movie habits, cat cuddles, and endless scrolling. Your social circle is nearly frozen because you hate dressing up for generic dates and replying to repetitive openers like "Have you eaten?" or "What are you doing?" You want a partner but do not want to go outside.',
    matchmakerAdvice:
      'The odds of destiny knocking while you stay home are lower than winning the lottery. You are naturally family-oriented and incredibly warm. Since you are too lazy to search, let us do it for you. No need to swipe generic apps — just stay home. Your matchmaker will screen, find someone on the same "chill/peaceful" frequency, and deliver them to you in a privately designed date.',
  },
};

export const BEDROOM_QUIZ = [
  {
    q: 'How often do you "scan the radar" for top-tier catches (handsome guys) on social media or in real life?',
    options: [
      { text: 'Pretty passive. Only notice when someone exceptionally outstanding appears right in front of me. Normally I do not actively search.', type: 'A' },
      { text: 'Low-key operating system. Outwardly indifferent but secretly saving photos and following top catches with anonymous accounts.', type: 'B' },
      { text: '24/7 scanning mode activated. Eyes light up at the sight of handsome guys, actively liking and interacting without missing anyone.', type: 'C' },
      { text: 'Mainly for entertainment. When I see someone hot, I drag the boys in the group to gossip and have fun.', type: 'D' },
    ],
  },
  {
    q: 'If you had to use a tech term to describe your "hardware" down there, which one would you pick?',
    options: [
      { text: 'Elegant design. Well-proportioned, focused on aesthetics and overall harmony.', type: 'A' },
      { text: 'Stealth Edition. Looks normal but when activated, it unleashes surprisingly high performance.', type: 'B' },
      { text: 'Ultra Overclocked. Massive size, grand and impressive, the pride of the manufacturer.', type: 'C' },
      { text: 'Compact Edition. Small, space-saving, easy to operate in any terrain.', type: 'D' },
    ],
  },
  {
    q: 'What is your "bedroom operation" battery capacity like in one night?',
    options: [
      { text: 'Eco Mode (Gentle). Light touches, one quality round then cuddling to sleep till morning is peaceful enough.', type: 'A' },
      { text: 'Boost charge mode. Round one may pass quickly but after a short rest I can recharge for round two.', type: 'B' },
      { text: 'Night grinding champion (5000mAh beast battery). Ready to grind multiple rounds all night without getting tired.', type: 'C' },
      { text: 'Fast charge technology. Quick and efficient resolution in 15 minutes, prioritizing performance so the rest of the time is for rest.', type: 'D' },
    ],
  },
  {
    q: 'When you "power on" for battle, what is your favorite operating style?',
    options: [
      { text: 'Customer service mode. Always checking in, gentle, afraid of causing pain, and love cuddling and soothing.', type: 'A' },
      { text: 'Last-minute flip mode. Pretend to be obedient at first to make the other person let their guard down, then flip the script and take control.', type: 'B' },
      { text: 'Sport Plus mode (Intense). Love possessing, being rough, a bit kinky/light pain, and crave intense stimulation.', type: 'C' },
      { text: 'Just doing it while cracking jokes mode. Sometimes in the heat of the moment I can still burst out laughing at a funny situation. No pressure to win or lose.', type: 'D' },
    ],
  },
  {
    q: 'In your thoughts or the most secret dreams, how often do you fantasize about bold "lights off" scenarios?',
    options: [
      { text: 'Very rarely. I am traditional romantic. Only when two people love each other deeply and the space is perfect does the feeling come.', type: 'A' },
      { text: 'Occasionally think about it but keep it to myself. Like ambiguous, teasing with eyes or text (Texting/Dirty talk).', type: 'B' },
      { text: 'Think about it frequently and extremely rich. Love roleplay scenarios, new locations, or explosive sensations.', type: 'C' },
      { text: 'Ideas jump around non-stop but mostly cheeky. Like watching funny 18+ content, treating sex as healthy entertainment.', type: 'D' },
    ],
  },
  {
    q: 'After "powering off" from a passionate night, which action makes you most satisfied?',
    options: [
      { text: 'Shower together, then cuddle under the blanket and have light heart-to-heart talk about life until we fall asleep.', type: 'A' },
      { text: 'Look at the other person\'s exhausted but satisfied expression and feel proud that I just "optimized the software" so well.', type: 'B' },
      { text: 'Maintain the possession, hug tightly so they cannot move, or keep thinking about the next scenario.', type: 'C' },
      { text: 'Get up together and immediately order bubble tea or late-night food to eat our fill while laughing.', type: 'D' },
    ],
  },
];

export const BEDROOM_RESULTS = {
  A: {
    title: 'Team Gentle / Soft',
    desc: 'You belong to the gentle, delicate school of love. Lights off is the time to be pampered and enjoy peace together.',
  },
  B: {
    title: 'Team Low-key / Outside Gentle Inside Wild',
    desc: 'Outwardly proper and low-key. Inside you possess a rich and surprising bedroom world.',
  },
  C: {
    title: 'Team Bedroom War God',
    desc: 'You have explosive energy, love possession and intense, bold experiences.',
  },
  D: {
    title: 'Team Humorous / High Efficiency',
    desc: 'You see sex as part of joy and laughter. High performance, no pressure, always with a fun atmosphere.',
  },
};

export const BEDROOM_VARIANTS: Record<
  string,
  { shareTitle: string; shareHook: string }
> = {
  A1: {
    shareTitle: '#INTROVERTED_KITTEN | #CHILL_OS',
    shareHook: '“In bed I am a good kitten, lights off I just want to cuddle and sleep. Do not make me a tyrant, I just want to be pampered! 🧸”',
  },
  A2: {
    shareTitle: '#PURE_LOVE | #PREMIUM_SOFT_VIBE',
    shareHook: '“Rough is not my style. Subtlety, slowness and deep kisses are the keys to activate this heart. 🥂”',
  },
  A3: {
    shareTitle: '#PRINCE_OF_PEACE | #ROMANTIC_DESIGN',
    shareHook: '“The world outside is stressful enough with deadlines. Lights off, let us switch to gentle Eco mode and love each other softly, okay? 🕊️”',
  },
  B1: {
    shareTitle: '#SHIRTED_MONSTER | #FLIP_MASTER',
    shareHook: '“Do not let my low-key appearance fool you. Step into the bedroom and I will switch to Sport Plus mode and you will not be able to keep up! ⚡”',
  },
  B2: {
    shareTitle: '#BEDROOM_CIPHER | #HIDDEN_CEO',
    shareHook: '“Outwardly a model intellectual, inside I own an amazingly rich collection of bedroom ideas. If you want to explore, you have to be patient and peel layer by layer! 🔐”',
  },
  B3: {
    shareTitle: '#TEXTING_MASTER | #INTELLECTUAL_WILD',
    shareHook: '“Stimulate the brain with top-tier dirty talk before battle. Once the machine is on, the performance explodes unexpectedly! 🧠”',
  },
  C1: {
    shareTitle: '#BEDROOM_TYRANT | #OVERCLOCKED_MASTER',
    shareHook: '“VIP config, high clock speed, one night grinding deadlines without fatigue. Whoever can handle this intense operation mode, submit your application now! 🔥”',
  },
  C2: {
    shareTitle: '#18+_MAGNET | #HANDSOME_RADAR',
    shareHook: '“My eyes have an automatic radar that scans for handsome guys within 5km. Salty taste, love to possess and crave explosive scenarios! ⛓️”',
  },
  C3: {
    shareTitle: '#PHYSICAL_BEAST | #POSSESSION_SYSTEM',
    shareHook: '“Love must be rough, must burn from eyes to skin. Infinite stamina, ready to dominate your night room! 🦁”',
  },
  D1: {
    shareTitle: '#FAST_CHARGE_15_MIN | #EFFICIENCY_GOD',
    shareHook: '“Time is precious like gold. I choose high-efficiency lifestyle, quick and clean resolution in 15 minutes then cuddle to sleep for health! 🔋”',
  },
  D2: {
    shareTitle: '#COMPACT_EDITION | #SPACE_SAVER_KING',
    shareHook: '“The right pot for the right lid. Compact pocket-sized config that is convenient for finding a perfectly fitting lid to switch to gentle mode all night. 📦”',
  },
  D3: {
    shareTitle: '#SALTY_VITAMIN_18+ | #BEDROOM_COMEDIAN',
    shareHook: '“Deadline pressure is tiring enough. In bed it must be fun and full of laughter. Sign up to be my lover to get both pleasure and nightly laughs! 🎢”',
  },
};

export const defaultFormData = {
  email: '', pin: '', fullName: '', nickname: '', dob: '', city: '', address: '',
  height: '', weight: '', bodyType: '', education: '', income: '', job: '',
  currentStatus: '', livingSpace: '',
  orientation: '', role: [] as string[], comingOut: '', rel: [] as string[],
  personality: [] as string[], pros: [] as string[], cons: [] as string[], substances: [] as string[],
  energy: '', lifestyle: '', hobbies: [] as string[], love: [] as string[],
  futurePlans: [] as string[], futureKids: '', financeShared: [] as string[], financeMindset: [] as string[], sexView: [] as string[],
  age: [] as string[], partnerRole: [] as string[], partnerBody: [] as string[], priority: '', redflag: [] as string[],
  messageToAdmin: '', avatar: [] as string[], socialLink: '', idCard: '',
  extraDetails: {
    additionalAnswers: {} as Record<string, string>,
    personalityResult: null as {
      title: string;
      desc: string;
      shareTitle: string;
      shareHook: string;
      typeKey: string;
      variantKey?: string;
      percent: number;
      answers: Record<number, string>;
    } | null,
    singleResult: null as {
      title: string;
      desc: string;
      shareTitle: string;
      shareHook: string;
      typeKey: string;
      variantKey?: string;
      percent: number;
      temperature: string;
      temperatureLabel: string;
      triggerTagD: boolean;
      tagDSupplement?: string;
      answers: Record<number, string>;
    } | null
  }
};